module.exports = __webpack_public_path__ + "static/media/hybriq.43d4b214.svg";